export const RATING_SENTIMENT_VERY_DISSATISFIED = 'veryDissatisfied';
export const RATING_SENTIMENT_DISSATISFIED = 'dissatisfied';
export const RATING_SENTIMENT_SATISFIED = 'satisfied';
export const RATING_SENTIMENT_VERY_SATISFIED = 'verySatisfied';
export const RATING_SENTIMENT_HIGHLY_SATISFIED = 'highlySatisfied';
export const REVIEW_SCORE_THRESHOLD_EXCELLENT = 4.4;
export const REVIEW_SCORE_THRESHOLD_VERY_GOOD = 4.1;
export const REVIEW_SCORE_THRESHOLD_GOOD = 3.75;
export const REVIEW_SCORE_THRESHOLD_FAIR = 3.5;